import request from '@/services/request'
import { getApiUrl } from '@/utils/tool'

export function getAllVipInfo(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/vip/get-all-vip-info',
    method: 'post',
    data: object
  })
}

export function getUpgradeInfo(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/vip/get-upgrade-info',
    method: 'post',
    data: object
  })
}

export function getPrizeInfo(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/vip/get-prize-info',
    method: 'post',
    data: object
  })
}

export function getRebateInfo(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/vip/get-rebate-info',
    method: 'post',
    data: object
  })
}

export function getDetailInfo() {
  return request({
    baseURL: getApiUrl(),
    url: '/vip/get-detail-info',
    method: 'post'
  })
}
